import { post } from '@core/adapt';

export default {
  exportData(token) {
    return post('/inn/initWithEb', { token }, {
      timeout: 30000,
    });
  },
};



// WEBPACK FOOTER //
// ./apis/epassport.js